import { Navigate } from "react-router-dom";
import { useJwtStorage } from "./hooks/useLocalStorage";
import { getUserPriority } from "./services/UserService";

const ProtectedRoute = ({ roles, redirectPath = "/", children }) => {
  const [_jwt] = useJwtStorage();

  if (!_jwt) {
    return <Navigate to={redirectPath} replace />;
  }

  const priority = getUserPriority(_jwt);
  if (!roles.includes(priority)) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
